import * as React from 'react';
import { styled } from '@mui/system';
import { 
    Container, 
    Box, 
    AppBar, 
    Toolbar, 
    Typography, 
    Link, 
    Button, 
    Stack 
} from '@mui/material';

// Styled components
const NavLink = styled('a')(({ theme }) => ({
    textDecoration: 'none',
    color: '#18191F',
    fontSize: '16px',
    margin: '0 15px',
    cursor: 'pointer',
    fontWeight: '600'
}));

const CustomButton = styled(Button)(({ theme, variant }) => ({
    borderRadius: '6px',
    ...(variant === 'login' && {
      backgroundColor: '#FFFFFF',
      color: '#263238',
      fontWeight: 600,
      height: "40px",
      width: "90px",
      '&:hover': {
        backgroundColor: '#F5F5F5'
      },
    }),
    ...(variant === 'signup' && {
      backgroundColor: '#263238',
      color: '#FFFFFF',
      fontWeight: 600,
      height: "40px",
      width: "91px",
      '&:hover': {
        backgroundColor: '#1E2A2F'
      },
    }),
}));

const TopBarSection = () => {
    return (
        <AppBar position="static" sx={{ backgroundColor: '#ffffff', boxShadow: 'none', height: '84px' }}>
      <Toolbar sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
        <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {/* Logo */}
          <img src='./companynamelogo.png' alt='Logo'></img>

          {/* Center Links 
          <Box sx={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
            {['Home', 'Product', 'Service', 'FAQ'].map((link) => (
              <NavLink key={link} href={`#${link.toLowerCase()}`}>
                {link}
              </NavLink>
            ))}
          </Box>
          */}
          {/* Buttons */}
          <Box sx={{ display: 'flex', gap: '10px' }}>
            <CustomButton variant="login" href="https://app.sigmatiqa.com">Log In</CustomButton>
          </Box>
        </Container>
      </Toolbar>
    </AppBar>
    );
};

export default TopBarSection;